import React from 'react';
import { PropTypes } from '~/utils';
import ReactMarkdown from 'react-markdown';

export function Markdown( props ) {
  const { content } = props;

  return (
    <ReactMarkdown skipHtml={true}>{content}</ReactMarkdown>
  );
}
Markdown.propTypes = {
  content : PropTypes.string.isRequired,
};
